import { Link } from "react-router";
import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import { EllipsisVerticalIcon, PrinterIcon } from "@heroicons/react/24/solid";
import { ArrowDownTrayIcon } from "@heroicons/react/24/outline";

interface PrintDownloadMenuProps {
	uniqueKey: string;
	printLabel?: string;
	onPrint?: () => void;
	downloadExcelLink?: string;
	downloadCsvLink?: string;
}

export default function PrintDownloadMenu(props: PrintDownloadMenuProps) {
	return (
		<>
			<Menu as="div" className="relative inline-block">
				<MenuButton className="flex items-center rounded-full text-gray-400 hover:text-gray-600">
					<span className="sr-only">Open options</span>
					<EllipsisVerticalIcon aria-hidden="true" className="size-8" />
				</MenuButton>

				<MenuItems
					anchor="bottom end"
					className="absolute z-10 pb-1 rounded-md bg-white py-1 shadow-lg ring-1 ring-black/5 focus:outline-none hover:cursor-pointer">
					{props.onPrint && (
						<MenuItem key={`print-${props.uniqueKey}`}>
							<a
								onClick={props.onPrint}
								className="block data-[focus]:bg-gray-100 px-4 py-2 text-sm text-gray-700">
								<div className="flex items-center">
									<PrinterIcon className="size-4 mr-2" aria-hidden="true" />
									Print {props.printLabel ?? ""}
								</div>
							</a>
						</MenuItem>
					)}
					{props.downloadExcelLink && (
						<MenuItem key={`download-excel-${props.uniqueKey}`}>
							<Link
								to={props.downloadExcelLink}
								download
								className="block data-[focus]:bg-gray-100 px-4 py-2 text-sm text-gray-700">
								<div className="flex items-center">
									<ArrowDownTrayIcon className="size-4 mr-2" aria-hidden="true" />
									Download Excel
								</div>
							</Link>
						</MenuItem>
					)}
					{props.downloadCsvLink && (
						<MenuItem key={`download-csv-${props.uniqueKey}`}>
							<Link
								to={props.downloadCsvLink}
								download
								className="block data-[focus]:bg-gray-100 px-4 py-2 text-sm text-gray-700">
								<div className="flex items-center">
									<ArrowDownTrayIcon className="size-4 mr-2" aria-hidden="true" />
									Download CSV
								</div>
							</Link>
						</MenuItem>
					)}
				</MenuItems>
			</Menu>
		</>
	);
}
